module.exports = __webpack_public_path__ + "img/新能源汽车_03.9a01ad48.png";